<script>
	import { user } from './stores.js';
	import { navigate } from 'svelte-routing';

	export let back = true;

	function log_in() {
		$user = "Antti";
	}

	function log_out() {
		$user = null;
		navigate("/");
	}
</script>

<style>
	#user-bar {
		height: 100px;
		position: fixed;
		left: 0;
		bottom: 0;
		right: 0;
		background: #FFF;
		text-align: center;
		padding: 20px;
		z-index: 10;
		box-shadow: 0px -3px 16px -9px rgba(0,0,0,0.75);
	}

	h2 {
		/*text-align: center;*/
	}

	.no-button {
		padding: 0px;
		border: none;
		cursor: pointer;
		font: inherit;
		background: transparent;
	}

	img {
		width: 100px;
		border-radius: 3px;
		vertical-align: middle;
	}
	.foo {
		display: inline-block;
		text-align: left;
		vertical-align: middle;
		padding: 0 20px;
	}
	.button {
		padding: 20px 100px;
		background: #ec6a33;
		color: #FFF;
		border-radius: 3px;
		border: none;

		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
	}

	.back {
		float: left;
		font-size: 20px;
		font-weight: bold;
		text-align: center;
	}
	.back a {
		display: block;
		width: 120px;
		height: 60px;
		line-height: 60px;
		background: #ec6a33;
		color: #FFF;
		border-radius: 5px;
	}
	.langs {
		float: right;
	}
	.lang {
		display: inline-block;
		padding: 10px 10px;
	}
</style>

<div id="user-bar">
	{#if back}
		<div class="back">
			<a href="javascript:history.go(-1)">← Back</a>
		</div>
	{/if}

	{#if $user}
		<!-- <h2>Hi, {$user}!</h2> -->
		<button on:click={log_out} class="button">Log out</button>
		<div class="foo"><strong>Logged in as<br>Antti</strong></div>
	{:else}
		
		<!-- <br> -->
		<button on:click={log_in} class="no-button">
			<img src="/kortti.jpg">
			<div class="foo"><strong>Scan your library card<br>for better suggestions!</strong></div>
		</button>
	{/if}


	<div class="langs">
		<div class="lang">🇫🇮<br>Suomeksi</div>
		<div class="lang">🇸🇪<br>På svenska</div>
	</div>
</div>
